// Copyright (C) 2025 by Posit Software, PBC.

import { updateUserPreferences } from "@/api/users";
import { CURRENT_USER_SET_JUMPSTART } from "@/store/modules/currentUser";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useStore } from "vuex";

export const useJumpstartStore = defineStore("jumpstart", () => {
  const active = ref(false);
  const hide = ref(true);
  const seen = ref(false);

  const vuexStore = useStore();

  const init = () => {
    if (vuexStore.state.currentUser.user.preferences?.hideJumpStart) {
      hide.value = true;
      return;
    }

    hide.value = false;
    if (!seen.value) {
      openModal();
    }
  };

  const updateHidden = async (isHidden) => {
    const user = vuexStore.state.currentUser.user;
    try {
      await updateUserPreferences(user.guid, { hideJumpStart: isHidden });
      hide.value = isHidden;
      vuexStore.commit(CURRENT_USER_SET_JUMPSTART, { isHidden });
    } catch (e) {
      return e;
      // NOTE: this error is silently ignored because we de not currently
      // have a good way to surface such errors or otherwise allow the user
      // to *do something* in response.
    }
  };

  const openModal = () => {
    active.value = true;
    seen.value = true;
  };

  const closeModal = () => {
    active.value = false;
  };

  const hideModal = () => {
    hide.value = true;
  };

  const showModal = () => {
    hide.value = false;
  };

  return {
    active,
    hide,
    seen,
    closeModal,
    hideModal,
    init,
    openModal,
    showModal,
    updateHidden,
  };
});
